import React from "react";
import CustomSelectionControl from "components/custom-selection-control/CustomSelectionControl";
import Select from "react-select";
import { components } from "react-select";
import styles from "./styles.module.scss";

const alpha = Array.from(Array(26)).map((e, i) => i + 65);
const alphabet = alpha.map((x) => String.fromCharCode(x));

const Option = (props) => {
  return (
    <components.Option {...props}>
      {props.isDisabled ? (
        props.label
      ) : (
        <div className={"d-flex align-items-center"}>
          <CustomSelectionControl
            className={styles["dropdown-checkbox"]}
            type={"checkbox"}
            checked={props.isSelected}
            onChange={() => null}
          />
          <span className={"rg-12 ml-2"}>{props.label}</span>
        </div>
      )}
    </components.Option>
  );
};

const selectStyles = {
  control: (styles) => ({
    ...styles,
    minWidth: 240,
    margin: 12,
    backgroundColor: "white",
    borderColor: "#ADCCFF",
    fontSize: 12,
    color: "#828282",
    boxShadow: "none",

    "&:hover": {
      borderColor: "#ADCCFF",
    },
  }),
  menu: () => ({ fontSize: 12 }),
  option: (styles) => ({
    ...styles,
    backgroundColor: null,
    color: "#333333",
    ":active": {
      ...styles[":active"],
      backgroundColor: null,
    },
    "&:hover": {
      backgroundColor: "#F3FAFF",
    },
  }),
};

const SelectWithSearch = ({ isOptionDisabled, ...props }) => {
  return (
    <Select
      components={{
        Option,
        IndicatorSeparator: null,
        DropdownIndicator: null,
      }}
      isOptionDisabled={(option) =>
        isOptionDisabled ||
        alphabet.includes(option.value) ||
        option.value === "#"
      }
      autoFocus
      isMulti
      menuIsOpen
      controlShouldRenderValue={false}
      isClearable={false}
      backspaceRemovesValue={false}
      hideSelectedOptions={false}
      placeholder="Search..."
      styles={selectStyles}
      tabSelectsValue={false}
      {...props}
    />
  );
};

export default SelectWithSearch;
